module.exports = __webpack_public_path__ + "img/19.bd50a455.png";